// Translation strings for the application

export const translations = {
  en: {
    // Form labels
    companyInformation: 'Company Information',
    companyName: 'Company Name',
    companyEmail: 'Company Email',
    companyAddress: 'Company Address',
    companyPhone: 'Phone Number',
    clientInformation: 'Client Information',
    clientName: 'Client Name',
    clientEmail: 'Client Email',
    clientCompany: 'Client Company',
    proposalDetails: 'Proposal Details',
    proposalTitle: 'Proposal Title',
    proposalDescription: 'Proposal Description',
    proposalNumber: 'Proposal Number',
    validUntil: 'Valid Until',
    bankInformation: 'Bank Information',
    bankName: 'Bank Name',
    accountHolderName: 'Account Holder Name',
    accountNumber: 'Account Number',
    iban: 'IBAN',
    swift: 'SWIFT/BIC Code',
    branchName: 'Branch Name',
    itemsPricing: 'Items & Pricing',
    addItem: 'Add Item',
    description: 'Description',
    quantity: 'Quantity',
    unit: 'Unit',
    unitPrice: 'Unit Price',
    total: 'Total',
    totalAmount: 'Total Amount',
    additionalNotes: 'Additional Notes',
    termsConditions: 'Terms & Conditions',
    companyLogo: 'Company Logo',
    uploadLogo: 'Upload Logo',
    changeLogo: 'Change Logo',
    noLogoUploaded: 'No logo uploaded',
    logoHint: 'Logo will appear in the top right of your proposal. Max size: 2MB',
    bankInfoHint: 'Bank details will be displayed at the bottom of the proposal',
    
    // PDF texts
    proposal: 'PROPOSAL',
    proposalNo: 'Proposal No.',
    proposalDate: 'Proposal Date',
    dueDate: 'Valid Until',
    billedBy: 'Proposed By',
    billedTo: 'Proposed To',
    email: 'Email',
    phone: 'Phone',
    serviceDescription: 'Service and description',
    calculation: 'Total',
    calculationDescription: '1 Unit x Unit Price x Quantity = Total',
    qty: 'Qty',
    rate: 'Rate',
    subTotal: 'Sub Total',
    discount: 'Discount(0%)',
    vat: 'VAT(0%)',
    bankAccountDetails: 'Bank Account Details',
    bankNameLabel: 'Bank Name:',
    accountHolderLabel: 'Account Holder:',
    accountNoLabel: 'Account No:',
    ibanLabel: 'IBAN:',
    swiftLabel: 'SWIFT:',
    branchLabel: 'Branch:',
    page: 'Page',
    of: 'of',
    
    // Buttons
    previewSendProposal: 'Preview & Send Proposal',
    preparingPreview: 'Preparing Preview...',
    confirmSendEmail: 'Confirm & Send Email',
    cancel: 'Cancel',
    creatingSending: 'Creating & Sending...',
    
    // Success
    proposalSentSuccessfully: 'Proposal Sent Successfully!',
    proposalSentMessage: 'Your proposal has been generated as a PDF and sent to the client\'s email address.',
    createAnotherProposal: 'Create Another Proposal',
    
    // Errors
    required: 'is required',
    invalidEmail: 'Invalid email address',
    
    // App header
    appTitle: 'Teklif - Proposal Generator',
    appSubtitle: 'Create professional proposals and send them to your clients'
  },
  
  tr: {
    // Form labels
    companyInformation: 'Şirket Bilgileri',
    companyName: 'Şirket Adı',
    companyEmail: 'Şirket E-posta',
    companyAddress: 'Şirket Adresi',
    companyPhone: 'Telefon Numarası',
    clientInformation: 'Müşteri Bilgileri',
    clientName: 'Müşteri Adı',
    clientEmail: 'Müşteri E-posta',
    clientCompany: 'Müşteri Şirketi',
    proposalDetails: 'Teklif Detayları',
    proposalTitle: 'Teklif Başlığı',
    proposalDescription: 'Teklif Açıklaması',
    proposalNumber: 'Teklif Numarası',
    validUntil: 'Geçerlilik Tarihi',
    bankInformation: 'Banka Bilgileri',
    bankName: 'Banka Adı',
    accountHolderName: 'Hesap Sahibi Adı',
    accountNumber: 'Hesap Numarası',
    iban: 'IBAN',
    swift: 'SWIFT/BIC Kodu',
    branchName: 'Şube Adı',
    itemsPricing: 'Kalemler ve Fiyatlandırma',
    addItem: 'Kalem Ekle',
    description: 'Açıklama',
    quantity: 'Miktar',
    unit: 'Birim',
    unitPrice: 'Birim Fiyat',
    total: 'Toplam',
    totalAmount: 'Toplam Tutar',
    additionalNotes: 'Ek Notlar',
    termsConditions: 'Şartlar ve Koşullar',
    companyLogo: 'Şirket Logosu',
    uploadLogo: 'Logo Yükle',
    changeLogo: 'Logoyu Değiştir',
    noLogoUploaded: 'Logo yüklenmedi',
    logoHint: 'Logo teklifinizin sağ üst köşesinde görünecektir. Maksimum boyut: 2MB',
    bankInfoHint: 'Banka detayları teklifin alt kısmında gösterilecektir',
    
    // PDF texts
    proposal: 'TEKLİF',
    proposalNo: 'Teklif No.',
    proposalDate: 'Teklif Tarihi',
    dueDate: 'Son Geçerlilik Tarihi',
    billedBy: 'Teklif Veren',
    billedTo: 'Teklif Verilen',
    email: 'E-posta',
    phone: 'Telefon',
    serviceDescription: 'Hizmet ve açıklama',
    calculation: 'Toplam',
    calculationDescription: '1 Birim x Birim Fiyat x Miktar = Toplam',
    qty: 'Miktar',
    rate: 'Fiyat',
    subTotal: 'Ara Toplam',
    discount: 'İndirim(0%)',
    vat: 'KDV(0%)',
    bankAccountDetails: 'Banka Hesap Detayları',
    bankNameLabel: 'Banka Adı:',
    accountHolderLabel: 'Hesap Sahibi:',
    accountNoLabel: 'Hesap No:',
    ibanLabel: 'IBAN:',
    swiftLabel: 'SWIFT:',
    branchLabel: 'Şube:',
    page: 'Sayfa',
    of: '/',
    
    // Buttons
    previewSendProposal: 'Önizleme ve Gönder',
    preparingPreview: 'Önizleme Hazırlanıyor...',
    confirmSendEmail: 'Onayla ve E-posta Gönder',
    cancel: 'İptal',
    creatingSending: 'Oluşturuluyor ve Gönderiliyor...',
    
    // Success
    proposalSentSuccessfully: 'Teklif Başarıyla Gönderildi!',
    proposalSentMessage: 'Teklifiniz PDF olarak oluşturuldu ve müşterinin e-posta adresine gönderildi.',
    createAnotherProposal: 'Yeni Teklif Oluştur',
    
    // Errors
    required: 'zorunludur',
    invalidEmail: 'Geçersiz e-posta adresi',
    
    // App header
    appTitle: 'Teklif - Teklif Oluşturucu',
    appSubtitle: 'Profesyonel teklifler oluşturun ve müşterilerinize gönderin'
  },
  
  fr: {
    // Form labels
    companyInformation: 'Informations sur l\'entreprise',
    companyName: 'Nom de l\'entreprise',
    companyEmail: 'E-mail de l\'entreprise',
    companyAddress: 'Adresse de l\'entreprise',
    companyPhone: 'Numéro de téléphone',
    clientInformation: 'Informations client',
    clientName: 'Nom du client',
    clientEmail: 'E-mail du client',
    clientCompany: 'Entreprise du client',
    proposalDetails: 'Détails de la proposition',
    proposalTitle: 'Titre de la proposition',
    proposalDescription: 'Description de la proposition',
    proposalNumber: 'Numéro de proposition',
    validUntil: 'Valable jusqu\'au',
    bankInformation: 'Informations bancaires',
    bankName: 'Nom de la banque',
    accountHolderName: 'Nom du titulaire du compte',
    accountNumber: 'Numéro de compte',
    iban: 'IBAN',
    swift: 'Code SWIFT/BIC',
    branchName: 'Nom de la succursale',
    itemsPricing: 'Articles et tarification',
    addItem: 'Ajouter un article',
    description: 'Description',
    quantity: 'Quantité',
    unit: 'Unité',
    unitPrice: 'Prix unitaire',
    total: 'Total',
    totalAmount: 'Montant total',
    additionalNotes: 'Notes supplémentaires',
    termsConditions: 'Termes et conditions',
    companyLogo: 'Logo de l\'entreprise',
    uploadLogo: 'Télécharger le logo',
    changeLogo: 'Changer le logo',
    noLogoUploaded: 'Aucun logo téléchargé',
    logoHint: 'Le logo apparaîtra en haut à droite de votre proposition. Taille max: 2MB',
    bankInfoHint: 'Les détails bancaires seront affichés en bas de la proposition',
    
    // PDF texts
    proposal: 'PROPOSITION',
    proposalNo: 'Proposition N°',
    proposalDate: 'Date de la proposition',
    dueDate: 'Valable jusqu\'au',
    billedBy: 'Proposé par',
    billedTo: 'Proposé à',
    email: 'E-mail',
    phone: 'Téléphone',
    serviceDescription: 'Service et description',
    calculation: 'Total',
    calculationDescription: '1 Unité x Prix unitaire x Quantité = Total',
    qty: 'Qté',
    rate: 'Tarif',
    subTotal: 'Sous-total',
    discount: 'Remise(0%)',
    vat: 'TVA(0%)',
    bankAccountDetails: 'Détails du compte bancaire',
    bankNameLabel: 'Nom de la banque:',
    accountHolderLabel: 'Titulaire du compte:',
    accountNoLabel: 'N° de compte:',
    ibanLabel: 'IBAN:',
    swiftLabel: 'SWIFT:',
    branchLabel: 'Succursale:',
    page: 'Page',
    of: 'de',
    
    // Buttons
    previewSendProposal: 'Aperçu et envoyer la proposition',
    preparingPreview: 'Préparation de l\'aperçu...',
    confirmSendEmail: 'Confirmer et envoyer l\'e-mail',
    cancel: 'Annuler',
    creatingSending: 'Création et envoi...',
    
    // Success
    proposalSentSuccessfully: 'Proposition envoyée avec succès!',
    proposalSentMessage: 'Votre proposition a été générée en PDF et envoyée à l\'adresse e-mail du client.',
    createAnotherProposal: 'Créer une autre proposition',
    
    // Errors
    required: 'est requis',
    invalidEmail: 'Adresse e-mail invalide',
    
    // App header
    appTitle: 'Teklif - Générateur de propositions',
    appSubtitle: 'Créez des propositions professionnelles et envoyez-les à vos clients'
  }
};

// Get current language from localStorage or default to Turkish
export const getLanguage = () => {
  const savedLang = localStorage.getItem('teklif_language');
  return savedLang || 'tr'; // Default to Turkish
};

// Set language
export const setLanguage = (lang) => {
  localStorage.setItem('teklif_language', lang);
};

// Get translation
export const t = (key) => {
  const lang = getLanguage();
  return translations[lang]?.[key] || translations.en[key] || key;
};
